module.exports = __webpack_public_path__ + "SP_SPT4-Trees-32d48e0566e5bcf2b9e940134a07dabf.png";